export default ({ store }: any) => {
  store.dispatch('app/initializeClient')
}
